<section class="price-planner">
  <header class="price-planner__header">
    <div>
      <p class="price-planner__eyebrow">Scenario Planning</p>
      <h3>{{ title }}</h3>
      <small *ngIf="subtitle">{{ subtitle }}</small>
    </div>
  </header>

  <div class="price-planner__state" *ngIf="loading">Loading planner...</div>
  <div class="price-planner__state price-planner__state--error" *ngIf="!loading && errorMessage && !sliders.length && !fields.length">
    {{ errorMessage }}
  </div>

  <ng-container *ngIf="!loading">
    <div class="price-planner__content">
      <section class="price-planner__card" *ngIf="sliders.length">
        <h4>Levers</h4>
        <div class="planner-slider" *ngFor="let slider of sliders; trackBy: trackByKey">
          <div class="planner-slider__header">
            <div>
              <strong>{{ slider.label }}</strong>
              <small *ngIf="slider.secondaryValue !== undefined">
                {{ formatDisplayValue(slider.secondaryValue, slider.secondaryPrefix || '', slider.secondarySuffix || '', slider.secondaryDecimals || 0) }}
              </small>
            </div>
            <span>{{ slider.value }}{{ slider.valueSuffix || '' }}</span>
          </div>
          <mat-slider [min]="slider.min" [max]="slider.max" [step]="slider.step">
            <input matSliderThumb [ngModel]="slider.value" (ngModelChange)="onSliderChange(slider, $event)" />
          </mat-slider>
        </div>
      </section>

      <section class="price-planner__card" *ngIf="fields.length">
        <h4>Inputs</h4>
        <label class="planner-field" *ngFor="let field of fields; trackBy: trackByKey">
          <span>{{ field.label }}</span>
          <input
            [type]="field.type === 'number' ? 'number' : 'text'"
            [(ngModel)]="field.value"
            [disabled]="field.editable === false"
          />
          <small *ngIf="field.helperText">{{ field.helperText }}</small>
        </label>
      </section>
    </div>

    <section class="price-planner__card" *ngIf="resultRows.length">
      <h4>Impact Summary</h4>
      <div class="result-row" *ngFor="let row of resultRows">
        <span>{{ row.label }}</span>
        <strong [ngClass]="resultToneClass(row.tone)">
          {{ formatDisplayValue(row.value, row.prefix || '', row.suffix || '', row.decimals || 0) }}
        </strong>
      </div>
    </section>

    <footer class="price-planner__footer" *ngIf="actionButton">
      <div class="price-planner__messages">
        <small class="is-success" *ngIf="actionMessage">{{ actionMessage }}</small>
        <small class="is-error" *ngIf="errorMessage && (sliders.length || fields.length)">{{ errorMessage }}</small>
      </div>
      <button mat-flat-button color="primary" type="button" (click)="onAction()" [disabled]="submitting">
        {{ submitting ? 'Applying...' : (actionButton.label || 'Apply Changes') }}
      </button>
    </footer>
  </ng-container>
</section>
